(ns ycweb.app.website.cart.pages.payment.zapper
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc zapper-payment < rum/reactive cmn/cursors
  {:will-unmount
   (fn [state]
     #?(:cljs
        (let [[app-atom] (:rum/args state)]
          (swap! app-atom update-in [:cart :zapper-payment] dissoc :loading? :widget-loaded?)
          (when-let [el (js/document.getElementById "zapperPayment")]
            (set! (.-innerHTML el) ""))
          (try
            (when-let [io (.-io js/window)]
              (doseq [k (js/Object.keys (or (.-managers io) #js {}))]
                (when-let [mgr (aget (.-managers io) k)]
                  (.close mgr))))
            (catch :default _))
          (js-delete js/window "zapper")
          (js-delete js/window "io")
          (doseq [el (array-seq (.querySelectorAll js/document.documentElement "[src*='zapper'],[src*='socket.io']"))]
            (.remove el))))
     state)
   :will-mount
   (fn [state]
     #?(:cljs
        (let [[app-atom process-atom cart-atom] (:rum/args state)
              order (get-in @cart-atom [:order])
              zapper-atom (rum/cursor-in app-atom [:cart :zapper-payment])]
          (when order
            (swap! zapper-atom assoc :loading? true :initiated? true)
            (model/zapper-initiate app-atom
              {:order-uuid (:uuid order)}
              (fn [response]
                (swap! zapper-atom assoc :loading? false)
                (if (:success response)
                  (do
                    (swap! zapper-atom assoc
                      :payment-uuid (:payment_uuid response)
                      :merchant-id (:merchant_id response)
                      :site-id (:site_id response)
                      :amount (:amount response)
                      :reference (:reference response))
                    (let [init-zapper
                          (fn []
                            ((.-zapper js/window)
                             (clj->js
                               {:selector "#zapperPayment"
                                :merchantId (:merchant_id response)
                                :siteId (:site_id response)
                                :billAmount (str (:amount response))
                                :reference (:reference response)
                                :paymentComplete
                                (fn [^js result]
                                  (when (= (.-status result) 1)
                                    ;; The widget's word is not enough — only move on
                                    ;; once the server has verified it with Zapper
                                    (model/zapper-check-status app-atom
                                      {:payment-uuid (:payment_uuid response)}
                                      (fn [check]
                                        (cond
                                          (not (and (:success check) (= (:payment_status check) "completed")))
                                          (swap! zapper-atom assoc :notice
                                            "Zapper reported your payment but we couldn't confirm it yet. Give it a moment — the page will update, or contact us with your order number.")

                                          (pos? (or (:balance_cents check) 0))
                                          (swap! zapper-atom assoc
                                            :initiated? false
                                            :notice (str "Thanks — we received a partial payment. R"
                                                      (u/currency-format (:balance_cents check))
                                                      " is still owing; please reload to pay the balance."))

                                          :else
                                          (do
                                            (swap! app-atom assoc-in [:order-summary :payment-confirmation] :zapper)
                                            (swap! (cmn/process-cursor app-atom) assoc :step :order/confirmation)))))))})))

                          load-widget
                          (fn []
                            (if (.-zapper js/window)
                              (init-zapper)
                              (let [script (js/document.createElement "script")]
                                (set! (.-src script) "https://code.zapper.com/zapper.js")
                                (set! (.-onload script) init-zapper)
                                (.appendChild (.-head js/document) script))))]
                      (if (js/document.querySelector "link[href*='zapper']")
                        (load-widget)
                        (let [link (js/document.createElement "link")]
                          (set! (.-rel link) "stylesheet")
                          (set! (.-type link) "text/css")
                          (set! (.-href link) "https://code.zapper.com/css/zapper.css")
                          (set! (.-onload link) load-widget)
                          (set! (.-onerror link) load-widget)
                          (.appendChild (.-head js/document) link)))))
                  (swap! zapper-atom assoc :error (:msg response))))))))
     state)}
  [app-atom process-atom cart-atom]
  (let [zapper-data (cmn/curact app-atom [:cart :zapper-payment])
        order (cmn/curact cart-atom [:order])]
    (cart.common/checkout-layout process-atom false
      (list
        (when (:error zapper-data)
          (rum/with-key (feedback/feedback :error (:error zapper-data) nil) "zapper-error"))
        (when (:notice zapper-data)
          (rum/with-key (feedback/feedback :info (:notice zapper-data) nil) "zapper-notice"))
        (rum/with-key
          (feedback/feedback :info
            (str "Amount owing: R" (u/currency-format (cmn/curact cart-atom [:totals :balance])))
            (str "Your order number is " (:number order)))
          "zapper-info")
        [:h2 {:key "zapper-heading" :class "yc-heading yc-heading--default"} "Pay with Zapper"]
        [:p {:key "zapper-desc" :class "yc-paragraph"} "Scan the QR code below with the Zapper app to complete your payment."]
        (when (:loading? zapper-data)
          [:p {:key "zapper-loading" :class "yc-paragraph"} "Loading Zapper..."])
        [:div {:key "zapper-payment" :id "zapperPayment"}]
        [:p {:key "zapper-alt" :class "yc-paragraph yc-paragraph--flush"}
         "Would you like to choose a "
         [:a.text-link
          (urlstate/href-props app-atom "order" "ShowCart"
            {:orderid (:id order) :h (:h order) :step "payment/method-postcheckout" :method "Zapper"})
          "different payment method?"]])

      (cart.common/checkout-cta-sidebar-simple
        nil nil (:number order) cart-atom {:total-key :balance}))))

(rum/defc zapper-page < rum/reactive cmn/cursors [app-atom process-atom cart-atom]
  (zapper-payment app-atom process-atom cart-atom))
